var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"header"},[_c('p',[_vm._v(_vm._s(_vm.roleLabel))])]),_c('div',{staticClass:"body"},[_c('p',[_vm._v(_vm._s(_vm.curStep))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }